import {
  INIT_TRACKS_OF_THE_WEEK,
  TRACKS_OF_WEEK_CHANGE_PAGE,
  TRACKS_OF_WEEK_SET_FAVORITE,
  TRACKS_OF_WEEK_DROP_FAVORITE,
} from "../actions/tracksOfTheWeekActions";

export default function tracksOfTheWeekReducer(
  state = { pages: undefined, currentPage: undefined, totalPage: undefined },
  action
) {
  if (action.type === INIT_TRACKS_OF_THE_WEEK) {
    // action.payload contain json result of tracks-of-week backend api response
    const currentPage = action.payload.current_page;
    const totalPages = action.payload.last_page;
    const currentPageTracks = action.payload.data;
    let initialTracksOfWeek = { pages: {}, currentPage, totalPages };
    initialTracksOfWeek.pages[currentPage] = currentPageTracks;
    return initialTracksOfWeek;
  }
  if (action.type === TRACKS_OF_WEEK_CHANGE_PAGE) {
    let newState = { ...state };
    let pageData = action.payload.pageData;
    let pageNumber = action.payload.page;
    if (pageData !== undefined) {
      newState.pages[pageNumber] = pageData;
    }
    newState.currentPage = pageNumber;
    return newState;
  }
  if (action.type === TRACKS_OF_WEEK_SET_FAVORITE) {
    const { songId, page } = action.payload;
    let newState = { ...state };
    let tracks = newState.pages[page].map((song) => {
      if (song.id === songId) {
        let newSong = { ...song };
        newSong.favorite = "true";
        return newSong;
      }
      return { ...song };
    });
    let newPages = { ...newState.pages };
    newPages[page] = tracks;
    newState.pages = newPages;
    return newState;
  }
  if (action.type === TRACKS_OF_WEEK_DROP_FAVORITE) {
    const { songId, page } = action.payload;
    let newState = { ...state };
    let tracks = newState.pages[page].map((song) => {
      if (song.id === songId) {
        let newSong = { ...song };
        newSong.favorite = false;
        return newSong;
      }
      return { ...song };
    });
    let newPages = { ...newState.pages };
    newPages[page] = tracks;
    newState.pages = newPages;
    return newState;
  }
  return state;
}
